import { uniqueAndSorted } from "@faire/retailer-visitor-shared/lib/uniqueAndSorted";
export var createCategoryPageFiltersQueryKeys = function(param) {
    var navigationPath = param.navigationPath, filterKeys = param.filterKeys, requestReferrer = param.requestReferrer;
    return [
        navigationPath,
        uniqueAndSorted(filterKeys),
        requestReferrer
    ];
};
